import type { AppDispatch } from '../../../app/store';
import { gridApi } from './gridApi';

/** Mark all subscribed grids (and entities) stale so RTK Query refetches without a full page reload. */
export const invalidateGridDataCache = (dispatch: AppDispatch) => {
  dispatch(gridApi.util.invalidateTags([{ type: 'GridData' }, { type: 'Entity' }]));
};
